import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { shareReplay, Subject } from 'rxjs';
import { LoginDTO } from '../types/authentication';
import { OAuth } from '../types/o-auth';
import { OAuthResponse } from '../types/o-auth.response';
import { OAuthErrorService } from './o-auth-error.service';
import { OAuthHttpService } from './o-auth-http.service';
import { OAuthStorageService } from './o-auth-storage.service';

@Injectable({
  providedIn: 'root',
})
export class OAuthService {
  private readonly oAuthSubject = new Subject<OAuth | null>();

  private http = inject(OAuthHttpService);
  private oAuthErrors = inject(OAuthErrorService);
  protected storage = inject(OAuthStorageService);

  get isAuth() {
    return this.storage.isAuth;
  }

  get oAuth$() {
    return this.oAuthSubject.asObservable().pipe(shareReplay(1));
  }

  public login(loginDTO: LoginDTO): void {
    this.http
      .login$(loginDTO)
      .subscribe({ next: this.nextLogin, error: this.errorLogin });
  }

  private nextLogin = (response: OAuthResponse): void => {
    if (!response.result.length) {
      this.oAuthSubject.next(null);
      return;
    }

    const oAuth = response.result[0];
    this.storage.set(oAuth);
    this.oAuthSubject.next(oAuth);
  };

  private errorLogin = (error: HttpErrorResponse): void => {
    this.oAuthErrors.errorLogin(error);
    this.oAuthSubject.next(null);
  };
}
